import React from 'react';
import { OnlineDatabaseCitingSection } from '../../components/citing/OnlineDatabaseCiting';
import { ContributorSection } from '../../components/ContributorSection';
import GenericSection from '../../components/GenericSection';
import { MoreOptionsSection } from '../../components/MoreOptions';
import { RecommendationBar } from '../../components/Shared';
import { useWritingForm } from '../../hooks/useWritingForm';
import { SourceType } from '../../types';
import { OnlineDatabaseContributorFunctions, ONLINE_DATABASE_PUB_INFO } from './constants';
import { ONLINE_DATABASE_SECTION_FIELDS } from './constants/fieldList/common';
export var ONLINE_DB_PUB_INFO_TEST_ID = 'online-database-pub-info-test-id';

// Component to render Online Database form.
var OnlineDatabaseForm = function OnlineDatabaseForm(_ref) {
  var onSourceChange = _ref.onSourceChange;
  useWritingForm(SourceType.ONLINE_DATABASE);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(OnlineDatabaseCitingSection, {
    onSourceChange: onSourceChange
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: OnlineDatabaseContributorFunctions
  }), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: ONLINE_DATABASE_SECTION_FIELDS,
    sectionTitle: ONLINE_DATABASE_PUB_INFO,
    name: "pubdatabase",
    "data-test": ONLINE_DB_PUB_INFO_TEST_ID,
    selectedTab: ""
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default OnlineDatabaseForm;